import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from '../state/appstate/appstate';
import Typography from '../helpers/fonts';
import { Row, Button, Col } from 'antd';
import { ROUTES } from '../helpers/constants';
import { useProductName } from '../helpers/useProductName';

export const ProductTitle: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const appState = useAppState();
  const styleName = useProductName();

  const changeStyle = () => {
    window.location.pathname = ROUTES.STYLES_SCREEN;
  }

  return (
    <Row justify={'space-between'} align={'middle'} wrap={false} style={{ marginBottom: '8px' }}>
      <Col>
        <Typography styleid={8}>
          {appState.styleProduct.product!.title}, {styleName}
        </Typography>
      </Col>
      <Col>
        <Button type="link" className="link-blue-button" onClick={changeStyle} style={{ textTransform: 'uppercase' }}>
          <Typography styleid={10} style={{ color: 'inherit' }}>
            {t("options.changeStyle")}
          </Typography>
        </Button>
      </Col>
    </Row>
  );
};
